<template>
	<div class="app--engagement-page" :data-id="definition.id">
		<div v-if="last && report" class="container bg--page border--page">
			<engagement-cfs-report></engagement-cfs-report>
		</div>
		<div v-for="p in panels" class="container bg--page border--page" :data-panel="p.id">
			<div v-if="individual" class="page-heading text--color-muted text--font-primary text--size-heading"
				:class="classes">
				<span :class="{ 'invisible': member(p.type).first_name == null || member(p.type).first_name == '' }">
					{{ member(p.type).name }}
				</span>&nbsp;
				<a v-if="p.type == 'COCLIENT' && empty(p)" href="javascript:void(0)" @click="remove(p)"
					class="pfp-engagement-link">({{ $t('app.common.remove').toLowerCase() }})</a>
			</div>
			<div class="app--engagement-groups page-content" :class="{ 'with-heading': individual }">
				<engagement-group v-for="g in groups" :panel="p" :definition="g"></engagement-group>
			</div>
		</div>
		<div class="page-footer" v-if="individual && !member('COCLIENT')">
			<app-button class="primary text-uppercase" @click.native="add" :loading="loading"
				:disabled="loading || working" icon="add" :label="trans('buttons.add_coclient')"></app-button>
			<p class="text--color-muted text--font-primary text--size-default">{{ trans('coclient.message') }}</p>
		</div>
		<div v-if="last && (documents || pending)" class="container bg--page border--page">
			<engagement-documents></engagement-documents>
		</div>
		<div v-if="last && pdfs" class="container bg--page border--page">
			<engagement-pdfs></engagement-pdfs>
		</div>
	</div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import store from '../store'
import Group from './Group'
import Docs from './helpers/Documents'
import Pdfs from './helpers/Pdfs'
import Report from './helpers/CfsReport'

export default {
	props: {
		definition: { type: Object, required: true }
	},
	data() {
		return { loading: false }
	},
	computed: {
		groups() { return store.state.template.groups.filter(g => g.panel == this.definition.id) },
		page() { return store.state.page },
		panels() { return store.getters['dataPanels'](this.definition) },
		individual() { return this.definition && this.definition.type == 'INDIVIDUAL' },
		last() { return this.definition && this.definition.type == 'FINISH' },
		documents() {
			return store.state.signatures.filter(s => s.filename != null).length > 0
				&& (store.state.type == 'engagement' || store.state.type == 'web-engagement')
		},
		pending() { return store.state.signature_pending },
		pdfs() { return store.state.pdfs.length > 0 },
		working() { return store.state.loading },
		complete() { return store.state.complete },
		classes() { let p = store.state.theme.print.pages.title; return 'print--size-' + p.size + ' print--color-' + p.color },
		report() {
			let report = store.state.elements.find(e => {
				let element = store.getters['customElement']('cfs_report')
				return element && e.definition == element.id
			})
			return report && report.value
		},
		template() { return store.state.template },
	},
	methods: {
		trans(key) {
			return store.getters['trans'](key) || this.$t('front.' + key)
		},
		member(type) {
			return store.state.members.find(m => m.type == type)
		},
		add() {
			if (!this.loading && !this.complete) {
				this.loading = true
				store.commit('ADD_MEMBER', { type: 'COCLIENT', name: this.trans('coclient.label'), active: false, coclient: true, security: "LOW" })
				store.commit('ADD_PANEL', { type: 'COCLIENT', id: uuid() })
				this.$nextTick(() => { this.loading = false })
			}
		},
		remove(p) {
			if (!this.loading && !this.complete) {
				this.loading = true
				store.commit('REMOVE_MEMBER', { type: 'COCLIENT' })
				store.commit('REMOVE_PANEL', p)
				this.$nextTick(() => { this.loading = false })
			}
		},
		empty(p) {
			return !this.member(p.type).exists
				&& store.state.elements.filter(e => e.panel == p.id && (e.value != null && e.value != false) && e.exists == true).length == 0
		}
	},
	components: {
		'engagement-group': Group,
		'engagement-documents': Docs,
		'engagement-pdfs': Pdfs,
		'engagement-cfs-report': Report
	}
}
</script>
